import React from 'react';
import { AppBar, makeStyles, Theme, Toolbar } from '@material-ui/core';
import { ModuleProps } from 'types';

export interface AppBarProps extends ModuleProps {
  className?: string;
}

const AppHeaderBar: React.FC<AppBarProps> = ({ className, children }) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <AppBar elevation={0} position="static">
        <Toolbar
          classes={{ root: styles.appBar, gutters: styles.appBarGutters }}
          className={className}
        >
          {children}
        </Toolbar>
      </AppBar>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => {
  const APP_BAR_HEIGHT = 70;
  const APP_MOBILE_BAR_HEIGHT = 72;

  return {
    root: {
      flexGrow: 1
    },
    appBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: APP_BAR_HEIGHT,
      background: 'white',
      color: 'black',
      borderBottom: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up('sm')]: {
        height: APP_MOBILE_BAR_HEIGHT
      }
    },
    appBarGutters: {
      paddingRight: 20,
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(5)
      }
    },
    title: {
      fontWeight: 600,
      lineHeight: theme.typography.pxToRem(40)
    },
    moreOptionsIcon: {
      color: 'black'
    },
    addButton: {
      background: theme.palette.primary.main,
      marginRight: theme.spacing(2)
    },
    searchContainer: {
      margin: 0,
      [theme.breakpoints.up('sm')]: {
        marginRight: theme.spacing(4)
      }
    },
    actionsHolder: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
});

export default AppHeaderBar;
